import Vue from 'vue'
import Dialog from './src/Dialog.vue'

//声明式调用组件
let DialogConstructor = Vue.extend(Dialog)

let instance

const show = function(message, option={}) {
    instance = new DialogConstructor({
        propsData:{
            message: message,
            ...option
        }
    })
    instance.$mount();
    document.body.appendChild(instance.$el);
}
  
export default show;

  
// export const show = (message, option={}) => {
//     const mountNode = document.createElement('div')
//     console.log("======trans message======");
//     console.log(message);
//     console.log(option);
//     const Instance = new Vue(Dialog,
//         {
//             show: true,
//             message,
//             type: 'error',
//             close: () =>{
//                 Instance.unmount(mountNode);
//                 document.body.removeChild(mountNode);
//             }
//         }
//     )
//     document.body.appendChild(mountNode);
//     Instance.$mount(mountNode);
// }